import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { getByTestID } from '../../utils/api';
import DOMPurify from 'dompurify';
import News from '../shorts/News';
import TestImageGallery from '../../utils/testImageGallery';
import CommentSection from '../comments/CommentSection';
import { Helmet } from 'react-helmet-async'; // ← NEU

import '../../assets/css/tests.css';

const Article = () => {
    const { articleID } = useParams(); // URL-Parameter holen
    const [tests, setTests] = useState(null);

    useEffect(() => {
        const fetchTestsArticle = async (id) => {
            try {
                const data = await getByTestID(id);
                setTests(data || null);
            } catch (err) {
                console.error(err);
            }
        };

        if (articleID) {
            fetchTestsArticle(articleID);
        }
    }, [articleID]);

    const formatDate = (isoString) => {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}.${month}.${year} um ${hours}:${minutes} Uhr`;
    };

    const getDescription = (htmlText, maxLength = 160) => {
        if (!htmlText) return '';
        const text = DOMPurify.sanitize(htmlText, { ALLOWED_TAGS: [] }); // nur Text
        return text.length > maxLength ? text.slice(0, maxLength) + '…' : text;
    };

    return (
        <>
            {tests && (
                <Helmet>
                    <title>{tests.titel}</title>
                    <meta
                        name="description"
                        content={getDescription(tests.infotext)}
                    />
                    <meta property="og:title" content={tests.titel} />
                    <meta
                        property="og:description"
                        content={getDescription(tests.infotext)}
                    />
                    <meta
                        property="og:image"
                        content={`/tests/img/games/${tests.cover || tests.image}`}
                    />
                    <meta property="og:type" content="article" />
                </Helmet>
            )}

            <main>
                <div className='wrapper'>
                    <div className='rows'>
                        <div className='row'>
                            <div className='category'>Tests</div>
                            <div className='tests'>
                                {tests ? (
                                    <div className='tests-entry tests-article' key={tests.ID}>
                                        <h1>{tests.titel}</h1>
                                        <div className='tests-author-date'>
                                            <img className='author-image' src={tests.user_image} alt={tests.author} />
                                            <strong>{tests.author}</strong>,&nbsp;
                                            {formatDate(tests.created_at)}
                                        </div>
                                        <img className="article-image" src={`/tests/img/games/${tests.image}`} alt={tests.titel} />
                                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(tests.infotext) }} />
                                        {/* Wertungstabelle */}
                                        <div className='benotung'>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Note</th>
                                                        <th>Thema</th>
                                                        <th>
                                                            <div className='reason'>
                                                                Begründung
                                                                <div className='info-benotung'>
                                                                    <a href="">So bewerten wir!</a>
                                                                </div>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr><td>{tests.grafiknote}</td><td>Grafik</td><td>{tests.grafiktext}</td></tr>
                                                    <tr><td>{tests.praesentationsnote}</td><td>Präsentation</td><td>{tests.praesentationstext}</td></tr>
                                                    <tr><td>{tests.gameplaynote}</td><td>Gameplay</td><td>{tests.gameplaytext}</td></tr>
                                                    <tr><td>{tests.funnote}</td><td>Gamingspaß</td><td>{tests.funtext}</td></tr>
                                                    <tr><td>{tests.soundnote}</td><td>Multiplayer</td><td>{tests.soundtext}</td></tr>
                                                    <tr>
                                                        <td><span className='gesamtnote'>{tests.gesamtnote}</span></td>
                                                        <td rowSpan={2}>Gesamtwertung <div className='info-gesamt'>(von 6)</div></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(tests.fazit) }} />
                                        <TestImageGallery testId={tests.ID} />
                                        <CommentSection postId={tests.ID} postType="tests" />
                                    </div>
                                ) : (
                                    <p>Lade Artikel...</p>
                                )}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='tests-entry-info-box'>
                                {tests ? (
                                    <div className='tests-entry-info' key={tests.ID}>
                                        <img src={`/tests/img/games/${tests.cover}`} alt={tests.titel} />
                                        <div className='tests-entry-info-text'>
                                            <strong>{tests.titel}</strong>
                                            <div>Genre: {tests.genre}</div>
                                            <div>Plattform: {tests.plattform}</div>
                                            <div>Erscheinungstermin: {tests.erscheinung}</div>
                                            <div>Kosten: {tests.kosten}</div>
                                            <div>Entwickler: {tests.entwickler}</div>
                                            <div>Publisher: {tests.publisher}</div>
                                        </div>
                                    </div>
                                ) : (
                                    <p>Lade Artikel...</p>
                                )}
                            </div>
                            <News />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Article;
